import settings_reducer from './setting'
export default {settings_reducer};